<div class="min-h-screen dark:bg-slate-900 p-4 md:p-8 text-sm text-slate-600 dark:text-slate-300">
  <div class="animate-fade-in flex flex-col md:flex-row md:items-end justify-between mb-8 gap-4">
    <div>
      <h1 class="text-3xl font-extrabold text-slate-800 dark:text-slate-100 tracking-tight">พื้นที่จอด (Parking Area)</h1>
      <p class="text-slate-500 dark:text-slate-400 mt-2 font-medium">จัดการพื้นที่ / lot / รูปภาพ base64 ตามลานที่เลือก</p>
    </div>
    <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
      <button (click)="onRefresh()" title="รีเฟรชข้อมูล"
        class="p-3 bg-white/95 dark:bg-slate-800/95 text-slate-500 rounded-2xl shadow-sm border border-slate-100/50 dark:border-slate-700 hover:text-amber-500 hover:shadow-md transition-all flex items-center justify-center cursor-pointer">
        <span class="material-icons">refresh</span>
      </button>
      <button *ngIf="canCreate" (click)="openCreate()"
        class="px-5 py-3 bg-amber-400 hover:bg-amber-500 text-white font-bold rounded-2xl shadow-lg shadow-amber-200/50 dark:shadow-none transition-all flex items-center justify-center gap-2 cursor-pointer">
        <span class="material-icons text-[18px]">add</span> เพิ่มพื้นที่
      </button>
    </div>
  </div>

  <div *ngIf="!selectedSiteId" class="mb-6 p-4 rounded-2xl bg-amber-50 dark:bg-amber-900/20 text-amber-700 dark:text-amber-300 font-medium">
    กรุณาเลือกลานจากแถบด้านบนก่อน
  </div>

  <div class="animate-fade-in bg-white/95 dark:bg-slate-800/95 rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.04)] border border-slate-100/50 dark:border-slate-700/50 overflow-hidden">
    <div class="p-6 border-b border-slate-100/70 dark:border-slate-700 flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <h3 class="text-lg font-bold text-slate-800 dark:text-slate-100 flex items-center gap-2">
        <span class="material-icons text-amber-500">map</span>รายการพื้นที่จอด
      </h3>
      <div class="relative w-full lg:max-w-md">
        <span class="absolute left-3 top-1/2 -translate-y-1/2 material-icons text-slate-400 text-[20px]">search</span>
        <input type="text" [ngModel]="searchText()" (ngModelChange)="searchText.set($event); onSearchChange()"
          placeholder="ค้นหาชื่อหรือ lot..."
          class="w-full pl-10 pr-4 py-2.5 bg-slate-50 dark:bg-slate-900 rounded-xl border border-slate-100 dark:border-slate-700 text-sm font-medium focus:ring-2 focus:ring-amber-200 focus:outline-none" />
      </div>
    </div>

    <div class="overflow-x-auto min-h-[300px] relative custom-scrollbar">
      <app-pss-loading *ngIf="isLoading()"></app-pss-loading>
      <table class="w-full text-left border-collapse" [class.opacity-50]="isLoading()">
        <thead>
          <tr class="bg-slate-50/80 dark:bg-slate-900/50 text-slate-400 text-[11px] uppercase tracking-wider">
            <th class="p-4 font-bold">ID</th>
            <th class="p-4 font-bold">ชื่อ</th>
            <th class="p-4 font-bold">Lot</th>
            <th class="p-4 font-bold">Provider</th>
            <th class="p-4 font-bold text-center">รูป</th>
            <th class="p-4 font-bold text-center">Online</th>
            <th class="p-4 font-bold text-right">จัดการ</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-slate-100 dark:divide-slate-700/50">
          <tr *ngFor="let item of items(); trackBy: trackById" class="hover:bg-slate-50/50 dark:hover:bg-slate-700/30 transition-colors">
            <td class="p-4 font-mono text-xs">{{ item.id }}</td>
            <td class="p-4 font-bold text-slate-800 dark:text-slate-100">{{ item.name }}</td>
            <td class="p-4">{{ item.lot || '-' }}</td>
            <td class="p-4">{{ item.providerName || '-' }}</td>
            <td class="p-4 text-center">
              <span class="text-xs font-semibold text-slate-500">
                {{ (item.hasImage1 ? 1 : 0) + (item.hasImage2 ? 1 : 0) + (item.hasImage3 ? 1 : 0) + (item.hasImage4 ? 1 : 0) }}/4
              </span>
            </td>
            <td class="p-4 text-center">
              <span class="px-2 py-1 rounded-lg text-[11px] font-bold"
                [class.bg-emerald-100]="item.isOnline" [class.text-emerald-700]="item.isOnline"
                [class.bg-slate-100]="!item.isOnline" [class.text-slate-500]="!item.isOnline">
                {{ item.isOnline ? 'Online' : 'Offline' }}
              </span>
            </td>
            <td class="p-4 text-right">
              <button *ngIf="canUpdate" (click)="openEdit(item)"
                class="p-2 rounded-xl text-slate-400 hover:text-amber-500 hover:bg-amber-50 dark:hover:bg-slate-700 transition-all cursor-pointer">
                <span class="material-icons text-[20px]">edit</span>
              </button>
            </td>
          </tr>
          <tr *ngIf="!isLoading() && items().length === 0">
            <td colspan="7" class="p-10 text-center text-slate-400">ไม่พบข้อมูล</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="p-4 border-t border-slate-100 dark:border-slate-700 flex flex-col sm:flex-row items-center justify-between gap-3">
      <div class="text-xs text-slate-400">
        แสดง {{ startItemIndex }}-{{ endItemIndex }} จาก {{ totalItems() }}
      </div>
      <div class="flex items-center gap-2">
        <select [ngModel]="pageSize()" (ngModelChange)="pageSize.set(+$event); currentPage.set(1); loadTable()"
          class="px-2 py-1.5 rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-900 text-xs">
          <option *ngFor="let s of pageSizeOptions" [ngValue]="s">{{ s }}/หน้า</option>
        </select>
        <button (click)="setPage(currentPage() - 1)" [disabled]="currentPage() <= 1"
          class="px-2 py-1 rounded-lg border border-slate-200 dark:border-slate-600 disabled:opacity-40 cursor-pointer">‹</button>
        <button *ngFor="let p of pagesArray" (click)="setPage(p)"
          class="px-2.5 py-1 rounded-lg text-xs font-bold cursor-pointer"
          [class.bg-amber-400]="p === currentPage()" [class.text-white]="p === currentPage()"
          [class.border]="p !== currentPage()" [class.border-slate-200]="p !== currentPage()">{{ p }}</button>
        <button (click)="setPage(currentPage() + 1)" [disabled]="currentPage() >= totalPages()"
          class="px-2 py-1 rounded-lg border border-slate-200 dark:border-slate-600 disabled:opacity-40 cursor-pointer">›</button>
      </div>
    </div>
  </div>
</div>

<app-modal-parking-area *ngIf="isModalOpen()"
  [itemId]="selectedId()"
  [siteId]="selectedSiteId"
  [siteName]="selectedSiteName"
  (close)="closeModal()"
  (saveSuccess)="loadTable()">
</app-modal-parking-area>
